module.exports = __webpack_public_path__ + "img/5.2f90cd45.jpg";